import vtkGenericRenderWindow from '@kitware/vtk.js/Rendering/Misc/GenericRenderWindow';

import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkXMLPolyDataReader from '@kitware/vtk.js/IO/XML/XMLPolyDataReader';
import vtkPLYReader from '@kitware/vtk.js/IO/Geometry/PLYReader';
import vtkTriangle from '@kitware/vtk.js/Common/DataModel/Triangle';
import vtkMath from '@kitware/vtk.js/Common/Core/Math';
import axios from 'axios';
import vtkDataArray from '@kitware/vtk.js/Common/Core/DataArray';
// import * as ort from 'onnxruntime-web'


//global variables?
export let sampleLatents = [];

let m_decoderSession = null;
let m_encoderSession = null;

export const createGenericRenderWindow = () => {
    
    
    let genericRenderWindow = vtkGenericRenderWindow.newInstance();    
    

    // const renderer = genericRenderWindow.getRenderer();

    // //modify camera callback?
    // const manipulators = genericRenderWindow
    //     .getInteractor()
    //     .getInteractorStyle()
    //     .getMouseManipulators();
    // for (let i = 0; i < manipulators.length; i++) {
    //     if (
    //         manipulators[i].isA(
    //             'vtkMouseCameraTrackballRotateManipulator'
    //         )
    //     ) {
    //         renderer.getActiveCamera().onModified(() => {
    //             const bds = renderer.computeVisiblePropBounds();
    //             const cen = [
    //                 (bds[0] + bds[1]) * 0.5,
    //                 (bds[2] + bds[3]) * 0.5,
    //                 (bds[4] + bds[5]) * 0.5,
    //             ];
    //             manipulators[i].setCenter(cen[0], cen[1], cen[2]);
    //         });
    //     }
    // }

    genericRenderWindow.getRenderer().setBackground(0, 0, 0, 0);        


    return genericRenderWindow;
}



const readArrayBuffer = async (file) =>{
    return new Promise((resolve, reject)=>{
        const filreader = new FileReader();
        filreader.onload = ()=>{
            resolve(filreader.result);
        }

        filreader.readAsArrayBuffer(file)
    })
}

export const readPolyData = async(path) =>{    
    let filename = path.split("/");
    filename = filename[ filename.length-1 ];
    let ext = filename.split(".")
    ext = ext[ext.length -1];
    

    const response = await axios.get(path, {responseType: "blob"});    
    
    const file = new File([response.data], filename);
    const arrayBuffer = await readArrayBuffer(file);

    let reader;
    if(ext === "vtp")
        reader = vtkXMLPolyDataReader.newInstance();
    else if(ext === "ply")
        reader = vtkPLYReader.newInstance();
    reader.parseAsArrayBuffer(arrayBuffer);
    reader.update();


    // const renderingObject = await readMesh(path);
    return reader.getOutputData();
}

export const makeActor = (polydata)=>{
    const mapper = vtkMapper.newInstance();
    mapper.setInputData(polydata);

    const actor = vtkActor.newInstance();
    actor.setMapper(mapper);

    return actor;
}

export const warmUp = async ()=>{

    const sessionOption = { 
        executionProviders: ['wasm'] ,
        graphOptimizationLevel: "all"        
    };
    m_decoderSession = await ort.InferenceSession.create('resources/sample_checkpoint_decoder.onnx', sessionOption);
    m_encoderSession = await ort.InferenceSession.create('resources/sample_checkpoint_encoder.onnx', sessionOption);


    //calculate latents
    for(let i=0 ; i<4 ; i++){
        let sample_polydata = await readPolyData(`resources/sample_${i+1}.ply`);
        let latent = await encoder(sample_polydata);
        console.log(latent);
        sampleLatents.push(latent);
    }
}

export const updateNormals = (polydata) =>{
    let pointsData = polydata.getPoints().getData();
    let polysData = polydata.getPolys().getData();    
    
    const normalsData = new Float32Array(pointsData.length);

    let numberOfPoints = 0;
    const polysDataLength = polysData.length;

    const cellPointIds = [0, 0, 0];


    for (let c = 0; c < polysDataLength; c += numberOfPoints + 1) {
        numberOfPoints = polysData[c];

        if (numberOfPoints < 3) {
            continue; // eslint-disable-line
        }

        for (let i = 1; i <= 3; ++i) {
            cellPointIds[i - 1] = 3 * polysData[c + i];
        }
        const cellNormal = [];

        vtkTriangle.computeNormal(
            pointsData.slice(cellPointIds[0], cellPointIds[0] + 3),
            pointsData.slice(cellPointIds[1], cellPointIds[1] + 3),
            pointsData.slice(cellPointIds[2], cellPointIds[2] + 3),
            cellNormal
        );

        for (let i = 1; i <= numberOfPoints; ++i) {
            let pointId = 3 * polysData[c + i];

            normalsData[pointId] += cellNormal[0];
            normalsData[++pointId] += cellNormal[1];
            normalsData[++pointId] += cellNormal[2];
        }
    }

    /* Normalize normals */

    for (let i = 0; i < pointsData.length; ) {
        const pointNormal = normalsData.slice(i, i + 3);

        vtkMath.normalize(pointNormal);

        normalsData[i++] = pointNormal[0];
        normalsData[i++] = pointNormal[1];
        normalsData[i++] = pointNormal[2];
    }
    let normals = polydata.getPointData().getNormals();
    if(!normals) {
        
        polydata.getPointData().setNormals(vtkDataArray.newInstance({values:normalsData}));
        // polydata.modified();
    }else{
        normals.setData(normalsData);
    }
    
}

export const encoder = async(polydata) =>{
    const input_tensor = new ort.Tensor('float32', polydata.getPoints().getData(), [1, polydata.getNumberOfPoints(), 3]);
    const latent = await m_encoderSession.run({input:input_tensor});

    return latent.output.data;
}

export const decoder = async(polydata, latent = new Float32Array(sampleLatents[1]) ) =>{    
    const input_tensor = new ort.Tensor('float32', latent  , [1, 16]);
    const pred = await m_decoderSession.run({input:input_tensor});
    const output = pred.output;

    // Update polydata    
    polydata.getPoints().setData(output.data);

    // Update Normals
    updateNormals(polydata);


    polydata.modified();    
}